import { type UserMeExEntity } from '../../aspida/@types'

export type PerformanceManagementRole =
  UserMeExEntity['performanceManagementRole']

export const PERFORMANCE_MANAGEMENT_ROLE = {
  NONE: 'NONE',
  ALLOWED: 'ALLOWED'
} as const satisfies Record<PerformanceManagementRole, string>
